import { USER_ROLES } from 'utils/constants';
import CalendarCircleUser from 'components/icons/CalendarCircleUser';
import TransactionIcon from 'components/icons/TransactionIcon';
import Desktops from 'components/icons/Desktops';
import VinCheck from 'components/icons/VinCheck';
import Saturation from 'components/icons/Saturation';
import Settings from 'components/icons/Settings';
import CameraLayout from 'components/icons/CameraLayout';
import Streams from 'components/icons/Streams';
import BugIcon from 'components/icons/BugIcon';
import RelayLogs from 'components/icons/RelayLogs';

export const routes = [
    {
        heading: 'Operations',
        path: '/all-desks',
        text: 'Desks',
        Icon: Desktops,
    },
    {
        path: '/all-events',
        text: 'All Events',
        Icon: TransactionIcon,
    },
    {
        path: '/manual-departures',
        text: 'Manual Departures',
        Icon: CalendarCircleUser,
    },
    {
        path: '/vin-processing',
        text: 'VIN Processing',
        Icon: VinCheck,
    },
    {
        allowedRoles: [USER_ROLES.ADMIN, USER_ROLES.TEAM_LEADER],
        path: '/saturation',
        text: 'Saturation',
        Icon: Saturation,
    },
    {
        heading: 'System Configuration',
        allowedRoles: [USER_ROLES.ADMIN],
        path: '/settings',
        text: 'Settings',
        Icon: Settings,
    },
    {
        allowedRoles: [USER_ROLES.ADMIN, USER_ROLES.TEAM_LEADER],
        path: '/camera-layouts',
        text: 'Camera Layouts',
        Icon: CameraLayout,
    },
    {
        path: '/streams',
        text: 'Streams',
        Icon: Streams,
    },
    {
        heading: 'Monitoring Logs',
        path: 'issue-reports',
        text: 'Issue reports',
        Icon: BugIcon,
    },
    {
        path: 'relay-logs',
        text: 'Relay Logs',
        Icon: RelayLogs,
    },
];
